<div
  class="tw-w-full tw-px-4 tw-py-2 tw-bg-white tw-justify-between tw-items-center tw-inline-flex tw-overflow-auto"
>
  <div class="tw-text-blue-800 tw-italic">
    {{ 'pagination.showing' | translate: paginationParam }}
  </div>
  <div class="tw-justify-center tw-items-center tw-gap-2 tw-flex">
    <div class="tw-w-6 tw-h-6 tw-relative"></div>
    <div
      class="tw-rounded tw-border tw-border-white tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-inline-flex"
    >
      <cohrex-button
        [small]="true"
        color="primaryLink"
        [disabled]="paginate?.current_page === 1"
        (click)="setPage($safeNavigationMigration(paginate?.current_page) - 1)"
      >
        <span class="material-icons tw-mr-1"> keyboard_arrow_left </span>
      </cohrex-button>
    </div>
    @for (page of paginate?.pages; track page) {
      <div
        class="tw-rounded tw-border tw-border-white tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-inline-flex"
      >
        <cohrex-button
          [small]="true"
          [color]="page === paginate?.current_page ? 'primary' : 'primaryLink'"
          (click)="setPage(page)"
          >{{ page }}</cohrex-button
        >
      </div>
    }
    <div
      class="tw-rounded tw-border tw-border-white tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-inline-flex"
    >
      <cohrex-button
        [small]="true"
        color="primaryLink"
        [disabled]="paginate?.current_page === paginate?.totalPages"
        (click)="setPage($safeNavigationMigration(paginate?.current_page) + 1)"
      >
        <span class="material-icons tw-mr-1"> keyboard_arrow_right </span>
      </cohrex-button>
    </div>
  </div>
</div>
